// extracted by mini-css-extract-plugin
module.exports = {"form":"ResetPassword_form__1e_lx","row":"ResetPassword_row__17Lau","center":"ResetPassword_center__21tr3","hrule":"ResetPassword_hrule__3gBvQ","page":"ResetPassword_page__2TYJg"};